@if (isLoading()) {
  <h2 class="text-primary-500 mb-2 text-body-lg-500 font-title">Buyer Contracts</h2>
  <lib-skeleton variant="fields" [count]="7" [columns]="5" [showHeader]="true" />
} @else if (contracts()) {
  <h2 class="text-primary-500 mb-2 text-body-lg-500 font-title">Buyer Contracts</h2>

  <div class="border border-slate-200 rounded-md">
    <!-- Panel header -->
    <div class="p-4">
      <span class="text-body-600 text-slate-700">Contract Details</span>
    </div>

    <!-- Panel content -->
    <div class="px-4 pb-4 flex flex-col gap-5">
      <!-- Row 1: 5 columns -->
      <div class="grid grid-cols-2 sm:!grid-cols-3 lg:!grid-cols-5 gap-x-4 gap-y-5">
        <div class="flex flex-col gap-0.5">
          <span class="text-body-xs text-slate-700 uppercase tracking-wider">Contract Date</span>
          <span class="text-body-500 text-slate-700">{{ fmt(contracts()!.contractDate) || '--' }}</span>
        </div>
        <div class="flex flex-col gap-0.5">
          <span class="text-body-xs text-slate-700 uppercase tracking-wider">Irrevocable Date</span>
          <span class="text-body-500 text-slate-700">{{ fmt(contracts()!.irrevocableDate) || '--' }}</span>
        </div>
        <div class="flex flex-col gap-0.5">
          <span class="text-body-xs text-slate-700 uppercase tracking-wider">Approval Date</span>
          <span class="text-body-500 text-slate-700">{{ fmt(contracts()!.approvalDate) || '--' }}</span>
        </div>
        <div class="flex flex-col gap-0.5">
          <span class="text-body-xs text-slate-700 uppercase tracking-wider">Final Sale Date</span>
          <span class="text-body-500 text-slate-700">{{ fmt(contracts()!.finalSaleDate) || '--' }}</span>
        </div>
        <div class="flex flex-col gap-0.5">
          <span class="text-body-xs text-slate-700 uppercase tracking-wider">Earnest Deposit</span>
          <span class="text-body-500 text-slate-700">
            {{ fmtAmount(contracts()!.earnestDeposit) }}
          </span>
        </div>

        <div class="flex flex-col gap-0.5">
          <span class="text-body-xs text-slate-700 uppercase tracking-wider">GST Rebate</span>
          <span class="text-body-500 text-slate-700 font-medium">{{
            contracts()!.eligibleForGSTRebate ? 'Eligible' : 'Not Eligible'
          }}</span>
        </div>
        <div class="flex flex-col gap-0.5">
          <span class="text-body-xs text-slate-700 uppercase tracking-wider">Investment Property</span>
          <span class="text-body-500 text-slate-700 font-medium">{{
            contracts()!.investmentProperty ? 'Yes' : 'No'
          }}</span>
        </div>
      </div>
    </div>
  </div>
} @else {
  <p class="text-body-sm text-slate-400 text-center py-6">Contract details not available.</p>
}
